(ns com.theplantscape.plant-web.components.tailwind.map-open-layers
  (:require [reagent.core :as r]
            ["ol/proj" :refer [fromLonLat toLonLat]]
            ["ol/Map$default" :as Map]
            ["ol/View$default" :as View]
            ["ol/layer/Tile$default" :as TileLayer]
            ["ol/source/XYZ$default" :as XYZ]))

(defn from-degrees [degrees]
  (* degrees (/ (.-PI js/Math) 180)))

(def osm {:url "https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png"})

(def arcgis #js {:attributions #js ["Powered by Esri',
                   'Source: Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community"],
                 :attributionsCollapsible false,
                 :url "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
                 :maxZoom 23})

(defn ui-map [lat-long #_#_long lat rotation pos]
  (let [map (r/atom nil)
        map-el (atom nil)
        lon-pos (r/atom 47.394167)
        lat-pos (r/atom 13.689167)]

    (r/create-class
     {:display-name "open-layer-map"
      :component-did-mount
      
      (fn [this]
        (prn "mount =============")
        (prn lat-long)
        (prn rotation)
        (prn pos)
        (prn @pos)
        (when lat-long
          (reset! map
                  (new Map #js
                       {:target (.-id @map-el)
                        :layers #js [(new TileLayer #js {:source (XYZ. arcgis)})]
                        :view (new View #js {:center (fromLonLat #js [(or (first lat-long) 0) (or (second lat-long) 0)])
                                             :rotation (from-degrees (or rotation 0.0))
                                             :zoom 19})}))

          (.on @map "moveend" (fn [evt]
                                (let [lon-lat (toLonLat (.getCenter (.getView @map)))]
                                  (prn "moveend")
                                  (when  (not-any? js/Number.isNaN lon-lat) 
                                    (when (not= lon-lat (-> @pos :values :diagram.settings/geo-location))
                                      (prn (-> @pos :values :diagram.settings/geo-location))
                                      (prn (vec lon-lat))
                                      ;(swap! pos assoc-in [:values :diagram.settings/geo-location] (vec lon-lat))
                                      ))

                                  
                                  #_(swap! pos assoc-in [:values :diagram.settings/longitude] (first lon-lat))
                                  #_(swap! pos assoc-in [:values :diagram.settings/latitude] (second lon-lat)))))))

      :component-did-update (fn [this old-argv]
                                (let [new-argv (rest (r/argv this))
                                      lon-lat (first new-argv)
                                      long (js/parseFloat (first lon-lat))
                                      lat (js/parseFloat (second lon-lat))
                                      rot (js/parseInt (nth new-argv 2))]

                                  (when (and @map long lat (nth new-argv 2)) 
                                    (-> (.setCenter (.getView @map) (fromLonLat #js [long lat])))
                                    (-> (.setRotation (.getView @map) (from-degrees (js/parseInt (nth new-argv 2))))))))

      :reagent-render
      (fn [] #_[long lat rotation]
        [:<>
         [:div#open-layer-map.bg-green-500 {:ref #(reset! map-el %) :style {:width "100%" :height "100%"}}]])})))

